// extracted by mini-css-extract-plugin
export default {"primary":"#f98b27","black":"#333","header":"Header_header__1Gquw"};